<template>
  <div class="flex flex-row items-center space-x-3" style="flex: none">
    <!-- <language-switcher /> -->
    <div class="flex flex-row items-center space-x-3" v-if="isAuthenticated == 'Undefined'">
      <router-link :to="registerUrl" v-if="isRegistrationOpen == 'true'" class="auth-link">
        <v-btn v-if="isRegistrationOpen" class="auth-btn auth-btn--register" rounded small>
          <v-icon left size="16">mdi-account-plus-outline</v-icon>
          {{ $t('register') }}
        </v-btn>
      </router-link>
      <router-link :to="loginUrl" class="auth-link">
        <v-btn class="auth-btn auth-btn--login" rounded small>
          <v-icon left size="16">mdi-login-variant</v-icon>
          {{ $t('login.title') }}
        </v-btn>
      </router-link>
    </div>
    <div class="flex flex-row items-center space-x-6" v-else>
      <user-menu />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import store from '@/store/store';
import UserMenu from '@/components/authentication/UserMenu.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

export default defineComponent({
  name: 'AuthMenu',
  components: {
    UserMenu,
    LanguageSwitcher,
  },
  data() {
    return {
      loginUrl: process.env.VUE_APP_LOGINPATH,
      registerUrl: process.env.VUE_APP_REGISTERPATH,
    };
  },
  setup() {
    const isRegistrationOpen = process.env.VUE_APP_REGISTRATION_OPEN;
    const isAuthenticated = computed(() => store.getters.fullName);

    return { isRegistrationOpen, isAuthenticated };
  },
});
</script>

<style scoped>
.auth-link {
  text-decoration: none;
}

.auth-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.3px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  padding: 0 18px !important;
  height: 36px !important;
}

.auth-btn--register {
  background: rgba(255, 255, 255, 0.12) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: #ffffff !important;
  backdrop-filter: blur(6px);
}

.auth-btn--register:hover {
  background: rgba(255, 255, 255, 0.22) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15) !important;
}

.auth-btn--login {
  background: linear-gradient(135deg, #00acc1 0%, #00838f 100%) !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: 0 2px 12px rgba(0, 172, 193, 0.3) !important;
}

.auth-btn--login:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 172, 193, 0.45) !important;
}
</style>
